// @ts-nocheck
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { IconPresentationProps } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import Close, { CloseOffset } from "@store/Library/Components/Toolkit/Icons/Close";
import { menuPanelRowResetStyles } from "@store/Themes/common/mixins/menu";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { buttonResetProps } from "@store/Themes/common/props/button";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { focusUpdateStyles, iconScalableStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

export interface MenuDrawerProps {
    headerCss?: StyledProp;
    closeButton?: ButtonPresentationProps;
    closeButtonIcon?: IconPresentationProps;
    wrapperCss?: StyledProp;
    menuCss?: StyledProp;
}

export interface MenuDrawerOptions {
    color: string;
    hoverColor: string;
    backgroundColor: string;
    borderColor: string;
}

export const menuDrawerGetProps = (options: MenuDrawerOptions): MenuDrawerProps => ({
    wrapperCss: css`
        background-color: ${getColor(options.backgroundColor)};
        color: ${getColor(options.color)};
    `,
    headerCss: css`
        ${menuPanelRowResetStyles()}
        border-bottom: 1px solid ${getColor(options.borderColor)};
        justify-content: flex-end;
        min-height: ${pxToRem(50)};
    `,
    closeButton: {
        ...buttonResetProps,
        css: css`
            ${buttonResetProps.css}
            ${focusUpdateStyles(true)}
            display: flex;
            height: 100%;
            padding: ${x => x.theme.design.menu.panel.rowPadding};
            padding-top: 0;
            padding-bottom: 0;
            color: ${getColor(options.color)};
            transition: ${transitionHoverStyles("color")};
            flex-shrink: 0;
            align-items: center;

            &:hover,
            &:active {
                color: ${getColor(options.hoverColor)};
            }
        `,
    },
    closeButtonIcon: {
        src: Close,
        css: css`
            ${iconScalableStyles(pxToRem(20), CloseOffset)}
            top: auto !important; /* Override offset provided by button parent */
        `,
    },
    menuCss: css`
        padding: ${x => x.theme.design.menu.panel.rowWrapperPadding};
    `,
});

export const menuPanelProps = menuDrawerGetProps({
    backgroundColor: "menu.mainNavigation",
    color: "menu.mainNavigation.accent", // Store Custom Code
    hoverColor: "menu.mainNavigation.hover",
    borderColor: "menu.mainNavigation.separator",
});
